'use strict';

var Backbone = require('backbone');
var $ = require('jquery');
var _ = require('underscore');
var config = require('../../js/config');
var mediator = require('mediatorjs');
var Analytics = require('../Analytics/Analytics');
import {parallelArrayEach} from '../../utilities/uiLoopHelpers';

var keyCode = 0;
var CategoryZeroListView = Backbone.View.extend({

  $levels: [], // Array of jQuery objects for each of the active levels
  $panes: [], // Array of jQuery objects for each of the panes in the menu
  totalPanes: 0, // number representation of the total number of panes
  mouseCoordinates: {}, // Mouse coordinates for navigation purposes
  lastMouseXCoordinates: 0, // last X axis for the current nav item for forgiving menu items
  currentPane: null, // number representation of the index for the pane ( this.$panes ) we are in
  levelAttribute: null, // Used to cache attributes
  levelCssSelector: null, // Used to cache attributes
  targetAttribute: null, // Used to cache attributes
  targetCssSelector: null, // Used to cache attributes
  itemThreshold: 200, // threshold for X axis in pixels for changing pane items

  events: {
    'mouseenter .CategoryZeroList-panel-item': 'willAddActive', // We have hovered over an item, should we add active?
    'mouseenter .CategoryZeroList-panel': 'didEnterPanel', // We have moved into another panel
    'mouseleave': 'closeMenu', // We have hovered outside of our menu
    'mousemove .CategoryZeroList-panel-item': 'didMoveOnItem', // Used for mouse detection in the -X axis to toggle active
    'click .CategoryZeroList-viewMore': 'clickedViewMore', // Future analytics?
    'focus .CategoryZeroList-panel-item a': 'willAddActiveOnFocus',
    'keydown .CategoryZeroList-panel-item a': 'willKeyDownOnActive'
  },

  initialize: function() {
    this.initializeVariables();
    this.initializeElements();
    this.moveFirstPaneElements();
    this.totalPanes = this.$panes.length;
  },


  // Cache our variables for use later
  initializeVariables: function() {
    this.levelAttribute = config.categoryZero.attributes.level;
    this.levelCssSelector = '[' + this.levelAttribute + ']';

    this.targetAttribute = config.categoryZero.attributes.target;
    this.targetCssSelector = '[' + this.targetAttribute + ']';
  },


  // Caching variables
  initializeElements: function() {
    this.$panes = this.$el.find(this.levelCssSelector);
    this.$productsHeading = this.$el.find('.CategoryZeroList-heading');
  },


  // initial setup for our method to move elements around
  moveFirstPaneElements: function() {
    // Move heading element into first pane,
    // This was needed because the to detect level 0 would require
    // the model to pass down the value two levels deep and is easier to do
    // on the FE rather than those shenanigans
    this.$productsHeading.prependTo(this.$panes[0]);
  },

  /**
   * We have hovered over an item, decide if we are trying to make it to the next menu pane
   * @param {event} e
   */
  willAddActive: function(e) {

    let $target = $(e.currentTarget);

    // get the integer value of the current level
    let level = this.getLevelFromTaget($target);

    this.currentPane = level;

    // Hide manufacturer if on 4th panel or beyond.
    if (level >= 3) {
      this.$el.find('.CategoryZeroList-manufacturers').addClass(config.classes.visuallyHidden);
    }

    // Is this our first selection in our panel?
    if (!this.$levels[level]) {
      this.addActive($target, level);

      // Have we entered the menu for the first time?
      if (level === 0) {
        mediator.trigger(config.events.categoryZero.openMenu, {
          $target: $target
        });
      }
    }
    else {
      // Make sure we don't double add the active class if our level is null
      // Are we moving in a positive X direction?
      if (e.clientX < (this.lastMouseXCoordinates + this.itemThreshold)) {
        if (!$target.hasClass('Icon--right_arrow')) {
          this.addActive($target, level);
        }
      }
    }

    this.lastMouseXCoordinates = e.clientX;

  },

  /**
   * Track analytics on panel interaction
   * @param {jQuery} $target
   * @param {integer} level
   */
  trackAnalytics: function($target, level) {
    // If there is already an element being tracked
    if (this.capturingPanelInteraction) {
      // If the element is current element then ignore
      if (this.capturingPanelInteraction.target === $target) {
        return;
      } else {
        // User moved too fast, clear tracking for previous element.
        clearTimeout(this.capturingPanelInteraction.timeout);
      }
    }
    // If element has been tracked before don't track again.
    if ($target.data('gtm-tracked')) {
      return;
    }
    // Setup state for current element being tracked
    this.capturingPanelInteraction = {
      target: $target
    };
    // Set timeout to trigger analytics.
    this.capturingPanelInteraction.timeout = setTimeout(() => {
      // Find child category anchor
      let targetUrl = $target.find('a:first').attr('href');
      // If anchor is not in child, it's parent
      if (!targetUrl) {
        targetUrl = $target.closest('a').attr('href');
      }
      Analytics.emitNewDataLayerEvent({
        event: config.analytics.events.hover,
        category: config.analytics.categories.megaMenu,
        action: config.analytics.actions.hover,
        label: 'Products - ' + level + ' - ' + targetUrl
      });
      // Flag element as tracked.
      $target.data('gtm-tracked', true);
    }, 500);
  },

  /**
   * Let's add the active class to our respective pane and item
   * @param {jQuery} $target
   * @param {integer} level
   */
  addActive: function($target, level) {
    let key = this.getKeyFromTarget($target);

    // Remove active classes on next panes
    this.removeActive();

    if (key) {
      // Remove currently active item at selected level
      this.$el.find(`[data-arrow-level=${level}] a.${config.classes.isActive}`).removeClass(config.classes.isActive);

      // Add class to the currently hovered target
      $target.find('a').addClass(config.classes.isActive);

      // Cache the current level
      this.$levels[level] = $target;

      // Remove all other currently active pane class
      this.$el.find(`[data-arrow-level].${config.categoryZero.classes.activePane}`).removeClass(config.categoryZero.classes.activePane);

      // Find our next pane and add class to the pane and active item
      if (this.$el.find(`[data-arrow-level-target="${key}"]`).length > 0) {
        // Hide manufacturer if expanding 3rd panel and there is another level to go.
        if (level === 2) {
          this.$el.find('.CategoryZeroList-manufacturers').addClass(config.classes.visuallyHidden);
        }
        this.$el.find(`[data-arrow-level=${level + 1}]`).addClass(config.classes.isActive + ' ' + config.categoryZero.classes.activePane);
        this.$el.find(`[data-arrow-level-target="${key}"]`).addClass(config.classes.isActive);
      }

      // Since we are showing the panel, we should track it.
      this.trackAnalytics($target, level);
    }

    mediator.trigger(config.events.categoryZero.didAddActive, {
      $target: $target,
      level: level,
      key: key
    });
  },

  /**
   * track mouse movement on each panel item, this caches so we only do complex logic when we know
   * we were moving to the next pane but have stopped
   * @param {event} e
   */
  didMoveOnItem: function(e) {
    // Are we moving in the left direction?
    if (e.clientX < this.lastMouseXCoordinates) {
      // We have moved in the opposite direction, user is trying to view a different pane
      let $target = $(e.target);
      let level = this.getLevelFromTaget($target);

      this.addActive($target, level);
    }
  },

  /**
   * We have moved into a new panel. Let's reset some things
   * @param {event} e
   */

  didFocusPanel: function(e) {
    console.log('didFocusPanel',e.target.parentNode);
    let $target = $(e.target.parentNode);
    let level = this.getLevelFromTaget($target);
    let key = this.getKeyFromTarget($target);

    mediator.trigger(config.events.categoryZero.didFocusPanel, {
      $target: $target,
      level: level,
      key: key
    });
    // If we are moving to a new panel and we're moving over a target link set that,
    // otherwise set the current level's target to null
    this.$levels[level] = (key) ? $target : null;
  },

  didEnterPanel: function(e) {
    let $target = $(e.target);
    let level = this.getLevelFromTaget($target);
    let key = this.getKeyFromTarget($target);

    mediator.trigger(config.events.categoryZero.didEnterPanel, {
      $target: $target,
      level: level,
      key: key
    });

    // If we are moving to a new panel and we're moving over a target link set that,
    // otherwise set the current level's target to null
    this.$levels[level] = (key) ? $target : null;
  },

  /**
   * Remove active classes to clean up the unneeded panes
   */
  removeActive: function() {

    // Get all panes past the current one and hide them
    this.$panes.slice(this.currentPane + 1).removeClass(config.classes.isActive);

    $(`.${config.classes.isActive}`, this.$panes.slice(this.currentPane + 1)).removeClass(config.classes.isActive);

    this.$el.find(this.$levels[this.currentPane]).removeClass(this.$panes.slice(this.currentPane + 1));

    if (this.currentPane < 3) {
      this.$el.find('.CategoryZeroList-manufacturers').removeClass(config.classes.visuallyHidden);
    }

    var numPanesToClose = this.totalPanes - this.currentPane;
    _.times(numPanesToClose, (currentLevel) => {
      let levelToModify = currentLevel + this.currentPane;
      if (this.$levels[levelToModify]) {
        this.$levels[levelToModify].removeClass(config.classes.isActive);
      }
    }, this);
  },

  /**
   * Helpful mediator event for analtyics on clicking view more
   * @param {event} e
   */
  clickedViewMore: function(e) {
    let $target = $(e.target);
    let category = this.getKeyFromTarget($target);
    let level = this.getLevelFromTaget($target);

    mediator.trigger(config.events.categoryZero.clickedViewMore, {
      $target: $target,
      category: category,
      level: level
    });
  },


  // We have navigated out of the flyout menu, bail out!
  closeMenu: function() {
    // Find all active classes and remove them
    this.$el.find('.' + config.classes.isActive, this.$el).removeClass(config.classes.isActive);

    // Reset levels
    this.$levels = [];

    // Reset last mouse X coordinates
    this.lastMouseXCoordinates = 0;

    // Reset manufacturer pane visibility
    this.$el.find('.CategoryZeroList-manufacturers').removeClass(config.classes.visuallyHidden);

    // Cleanup active pane class
    this.$el.find(`[data-arrow-level].${config.categoryZero.classes.activePane}`).removeClass(config.categoryZero.classes.activePane);

    // Stop tracking mouse
    this.$el.off('mousemove');

    mediator.trigger(config.events.categoryZero.closeMenu, {});
  },

  /**
   * Helper method for getting the level key from the $target
   * @param $target
   * @returns {number}
   */
  getLevelFromTaget: function($target) {
    return +$target.closest(this.levelCssSelector).attr(this.levelAttribute);
  },

  /**
   * Helper method for getting the category key from the $target
   * @param $target
   * @returns {string}
   */
  getKeyFromTarget: function($target) {
    return $target.closest(this.targetCssSelector).attr(this.targetAttribute);
  },
  /**
  * We have focus on an item, decide if we are trying to make it to the next menu pane
  * @param {event} e
  */
  willAddActiveOnFocus: function(e) {
    if (keyCode === config.key.right) {
      return;
    }
    else {
      let focusedEl = document.activeElement;
      let parent = focusedEl.closest('.CategoryZeroList-panel');
      let variab = parent.getAttribute('data-arrow-level');
      if (variab === '1') {
        var x = parent.querySelector('a.is-active');
        if (x) {
          x.className = '';
        }
        focusedEl.className += 'is-active';
        return;
      }
      else {
        this.closeMenu();
        let $target = $(e.currentTarget.parentNode);
        this.willAddActiveOnFocusOrMouseOver(e, $target);
      }
    }
  },

  willAddActiveOnFocusOrMouseOver: function(e, $target) {
    // get the integer value of the current level
    let level = this.getLevelFromTaget($target);
    this.currentPane = level;
    // Hide manufacturer if on 4th panel or beyond.
    if (level >= 3) {
      this.$el.find('.CategoryZeroList-manufacturers').addClass(config.classes.visuallyHidden);
    }
    // Is this our first selection in our panel?
    if (!this.$levels[level]) {
      this.addActive($target, level);
      // Have we entered the menu for the first time?
      if (level === 0) {
        mediator.trigger(config.events.categoryZero.openMenu, {
          $target: $target
        });
      }
    }
    else {
      // Make sure we don't double add the active class if our level is null
      // Are we moving in a positive X direction?
      if (e.clientX < (this.lastMouseXCoordinates + this.itemThreshold)) {
        if (!$target.hasClass('Icon--right_arrow')) {
          this.addActive($target, level);
        }
      }
    }
    this.lastMouseXCoordinates = e.clientX;
  },

  willKeyDownOnActive: function(e) {
    keyCode = e.keycode || e.which;
    if (keyCode === config.key.right) {
      let nextTargetDiv = document.querySelector('[class="CategoryZeroList-panel is-active is-active-pane"][data-arrow-level="1"]');
      if (nextTargetDiv) {
        let nextTar = nextTargetDiv.querySelector('.is-active');
        let link = nextTar.querySelector('ul li a');
        if (link) {
          link.className += 'is-active';
          link.focus();
        }
      }
    }
    if (keyCode === config.key.left) {
      let nextTargetDiv = document.activeElement.closest('.CategoryZeroList-categories').querySelector('[class="CategoryZeroList-panel"][data-arrow-level="0"]').querySelector('a.is-active');
      if (nextTargetDiv) {
        nextTargetDiv.focus();
      }
    }
  }
});

export function create($parent) {
  let elements = $parent.find('.CategoryZeroList');
  parallelArrayEach(elements, (el) => new CategoryZeroListView({ el: el }));
}




// WEBPACK FOOTER //
// ./assets/components/CategoryZeroList/CategoryZeroListView.js